/**
 * @file Contains customization for MuiTooltip Component
 */

import { Components } from '@mui/material';

import { colorNeutral } from '../colors';

const MuiTooltip: Components['MuiTooltip'] = {
  defaultProps: {
    disableTouchListener: true,
    placement: 'top',
  },
  styleOverrides: {
    tooltip: {
      backgroundColor: colorNeutral[800],
      borderRadius: 'var(--border-radius-small)',
      fontSize: 'var(--font-sm)',
      fontWeight: 'var(--font-medium)',
      maxWidth: 'var(--preference-tooltip-max-width)',
      padding: 'var(--spacing-tiny) var(--spacing-small)',
      textAlign: 'left',
    },
  },
};
export default MuiTooltip;
